<div style="text-align: center;">
    <h1 style="margin: 0px;">How it Works?</h1>
</div>
<div class="body">
    <div class="container">
        <div class="features">
            <div class="feature-item first" id="feature-1">
                <div class="icon">
                    <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                        <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                            d="M9.75 17L9 20l-1 1h8l-1-1-.75-3M3 13h18M5 17h14a2 2 0 002-2V5a2 2 0 00-2-2H5a2 2 0 00-2 2v10a2 2 0 002 2z" />
                    </svg>
                </div>
                <div class="radio"></div>
                <p class="feature-text">Manage and monitor social media accounts for effective online engagement.</p>
            </div>

            <div class="feature-item" id="feature-2">
                <div class="icon">
                    <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                        <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                            d="M8 7V3m8 4V3m-9 8h10M5 21h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v12a2 2 0 002 2z" />
                    </svg>
                </div>
                <div class="radio"></div>
                <p class="feature-text">Plan and organize marketing campaigns using a detailed content calendar.</p>
            </div>

            <div class="feature-item" id="feature-3">
                <div class="icon">
                    <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                        <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                            d="M17 20h5v-2a3 3 0 00-5.356-1.857M17 20H7m10 0v-2c0-.656-.126-1.283-.356-1.857M7 20H2v-2a3 3 0 015.356-1.857M7 20v-2c0-.656.126-1.283.356-1.857m0 0a5.002 5.002 0 019.288 0M15 7a3 3 0 11-6 0 3 3 0 016 0zm6 3a2 2 0 11-4 0 2 2 0zM7 10a2 2 0 11-4 0 2 2 0 014 0z" />
                    </svg>
                </div>
                <div class="radio"></div>
                <p class="feature-text">Streamline workflows with the business manager tool for team collaboration.</p>
            </div>

            <div class="feature-item last" id="feature-4">
                <div class="icon">
                    <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                        <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                            d="M16 7a4 4 0 11-8 0 4 4 0 018 0zM12 14a7 7 0 00-7 7h14a7 7 0 00-7-7z" />
                    </svg>
                </div>
                <div class="radio"></div>
                <p class="feature-text">Customize and update user profiles for personalized account settings.</p>
            </div>
        </div>
    </div>

    <div class="img-div">
        <div class="video-img-container">
            <img src="\assets\mackbook.png" alt="macbook">
            <div class="video-container">
                <iframe id="youtube-video" width="560" height="315"
                src="https://www.youtube.com/embed/rWRkFv2QYEY?enablejsapi=1&rel=0&playlist=rWRkFv2QYEY&loop=1"

                    title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
                    allowfullscreen>
                </iframe>
            </div>
        </div>
    </div>
</div>

<script>
    document.addEventListener("DOMContentLoaded", function () {
        const featureItems = document.querySelectorAll('.feature-item');
        const intervals = [
            { time: 0, id: "feature-1" },
            { time: 10, id: "feature-2" },
            { time: 20, id: "feature-3" },
            { time: 30, id: "feature-4" }
        ];

        let player;

        function onYouTubeIframeAPIReady() {
            player = new YT.Player('youtube-video', {
                events: {
                    onStateChange: onPlayerStateChange
                }
            });
        }

        function onPlayerStateChange(event) {
            if (event.data === YT.PlayerState.PLAYING) {
                monitorPlaybackTime();
            }
        }

        function monitorPlaybackTime() {
            setInterval(() => {
                const currentTime = Math.floor(player.getCurrentTime());
                intervals.forEach((interval, index) => {
                    const element = document.getElementById(interval.id);
                    const nextTime = intervals[index + 1]?.time || Infinity; // Use Infinity for the last interval
                    if (currentTime >= interval.time && currentTime < nextTime) {
                        element?.classList.add('highlight');
                    } else {
                        element?.classList.remove('highlight');
                    }
                });
            }, 1000); // Check every second
        }

        // Load YouTube API script dynamically
        const tag = document.createElement("script");
        tag.src = "https://www.youtube.com/iframe_api";
        const firstScriptTag = document.getElementsByTagName("script")[0];
        firstScriptTag.parentNode.insertBefore(tag, firstScriptTag);

        // Expose the YouTube API ready function globally
        window.onYouTubeIframeAPIReady = onYouTubeIframeAPIReady;
    });
</script>
